import { createAsyncThunk } from "@reduxjs/toolkit";
import SaleService from "../../services/sale.service";
import PartiesService from "../../services/parties.service";
import LedgerService from "../../services/ledger.service";
import SettingsService from "../../services/settings.service";
import ItemsService from "../../services/items.service";
import ProformaInvoiceService from "../../services/proforma-invoice.service";

const handleThunkError = (error, thunkAPI) => {
    const message =
        (error.response &&
            error.response.data &&
            (error.response.data.message ||
                (error.response.data.messages && error.response.data.messages.error))) ||
        error.message ||
        error.toString();
    return thunkAPI.rejectWithValue({ message });
};

// Parties / Customers
export const ListProformaParties = createAsyncThunk(
    "/proforma-invoice/listParties",
    async (item, thunkAPI) => {
        try {
            return await PartiesService.ListParties(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// States (for billing/shipping address)
export const GetProformaState = createAsyncThunk(
    "/proforma-invoice/getState",
    async (_, thunkAPI) => {
        try {
            return await LedgerService.GetState();
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Settings (invoice prefix, e-invoice flag, etc.)
export const GetProformaSettings = createAsyncThunk(
    "/proforma-invoice/getSettings",
    async (item, thunkAPI) => {
        try {
            return await SettingsService.Getsettings(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Units
export const GetProformaUnits = createAsyncThunk(
    "/proforma-invoice/getUnits",
    async (_, thunkAPI) => {
        try {
            return await SettingsService.Getunits();
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Items
export const ListProformaItems = createAsyncThunk(
    "/proforma-invoice/listItems",
    async (item, thunkAPI) => {
        try {
            return await ItemsService.ListItems(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

export const GetProformaItemDetail = createAsyncThunk(
    "/proforma-invoice/getItemDetail",
    async (item, thunkAPI) => {
        try {
            return await SaleService.Getsingledetail(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

export const GetProformaCurrentStock = createAsyncThunk(
    "/proforma-invoice/getCurrentStock",
    async (item, thunkAPI) => {
        try {
            return await SaleService.GetCurrentStock(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Invoice number
export const GetProformaInvoiceNextNumber = createAsyncThunk(
    "/proforma-invoice/getNextNumber",
    async (item, thunkAPI) => {
        try {
            return await ProformaInvoiceService.NextNumber(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// List
export const GetProformaInvoiceList = createAsyncThunk(
    "/proforma-invoice/list",
    async (item, thunkAPI) => {
        try {
            return await ProformaInvoiceService.List(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Add
export const AddProformaInvoice = createAsyncThunk(
    "/proforma-invoice/add",
    async (item, thunkAPI) => {
        try {
            return await ProformaInvoiceService.Add(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Single details
export const GetProformaInvoiceDetails = createAsyncThunk(
    "/proforma-invoice/getDetails",
    async (item, thunkAPI) => {
        try {
            return await ProformaInvoiceService.Detail(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Customer detail (billing/shipping info for a selected party)
export const GetProformaCustomerDetail = createAsyncThunk(
    "/proforma-invoice/getCustomerDetail",
    async (item, thunkAPI) => {
        try {
            return await ProformaInvoiceService.Customer(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Update
export const UpdateProformaInvoice = createAsyncThunk(
    "/proforma-invoice/update",
    async (item, thunkAPI) => {
        try {
            return await ProformaInvoiceService.Update(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// Delete
export const DeleteProformaInvoice = createAsyncThunk(
    "/proforma-invoice/delete",
    async (item, thunkAPI) => {
        try {
            return await ProformaInvoiceService.Delete(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// PDF (bulk download)
export const DownloadProformaInvoicePdf = createAsyncThunk(
    "/proforma-invoice/downloadPdf",
    async (item, thunkAPI) => {
        try {
            return await SaleService.InvoicePdf(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

// E-invoice / IRN
export const GenerateProformaIrn = createAsyncThunk(
    "/proforma-invoice/generateIrn",
    async (item, thunkAPI) => {
        try {
            return await SaleService.GenerateIrn(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);

export const GetProformaIrnDetail = createAsyncThunk(
    "/proforma-invoice/getIrnDetail",
    async (item, thunkAPI) => {
        try {
            return await SaleService.Getirndetail(item);
        } catch (error) {
            return handleThunkError(error, thunkAPI);
        }
    }
);
